import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'

import { DefaultState } from '../reducers/DefaultState'

const getCompareIdState = (state) => {
  return state.calendar
}

const getCalendarState = createSelector(
  [getCompareIdState],
  (state) => {
    return (state || {}).calendar || DefaultState
  })

const getCalendarExportState = createSelector(
  [getCompareIdState],
  (state) => {
    return (state || {}).export || DefaultState
  })

const makeCalendarSelector = () => {
  return createSelector(
    [getCalendarState],
    (details) => {
      return {
        isFetching: SelectorUtils.isFetching(details),
        error: details.error,
        details: details.details
      }
    }
  )
}

const makeCalendarExportSelector = () => {
  return createSelector(
    [getCalendarExportState],
    (details) => {
      return {
        isFetching: details.isFetching,
        error: details.error,
        details: details.details
      }
    }
  )
}

export {
  makeCalendarSelector,
  makeCalendarExportSelector
}
